"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
require("./styles/pricelist.scss");
var controllers_1 = require("./controllers");
var services_1 = require("./services");
var routes_1 = __importDefault(require("./config/routes"));
/**
 * @ngdoc module
 * @module rinca.apps.discount
 * @name rinca.apps.discount
 * @packageName rinca.apps
 * @description A module that includes the discount component.
 */
angular.module('rinca.apps.pricelist', ['ui.router'])
    .controller('PricelistController', controllers_1.PricelistController)
    .service('_pricelist', services_1.PricelistService)
    .config(routes_1.default);



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/pricelists/index.js
// module id = 402
// module chunks = 0